<template>
    <div class="game-results" v-if="game.status == 'completed'">
        <b-modal id="modal-game-results" :title="__('results.game_results')" @hidden="backToMatchmaking" size="xl">
            <template v-if="parsedContent.length > 0">
            <div class="results">
                <game-asset-score-player
                    :player_name="player.name"
                    :player_id="player.id"
                    :score_player="parsedContent[currentLeg].players[player.id].score"
                    :sets_player="legsets[currentLeg][player.id].sets"
                    :legs_player="legsets[currentLeg][player.id].legs"
                    :singlescore_player="JSON.stringify(parsedContent[currentLeg].players[player.id].singlescores ? parsedContent[currentLeg].players[player.id] : [])"
                    :winner="parsedContent[currentLeg].winner.name"
                    :startplayer="parsedContent[currentLeg].startplayer"
                    :active_player="parsedContent[currentLeg].winner.id == player.id"
                    :content="parsedContent[currentLeg].content"
                    :throw_player="parsedContent[currentLeg].players[player.id].lastthrow"
                    :deactivate_smallscore="true"
                    :gm="gm"
                    v-for="player, idx in players"
                    :key="idx"
                />
            </div>

            <template v-if="!showGameStats">
                <div class="history-changer">
                    <a href="#" @click="changeLeg(-1)" v-if="currentLeg > 0"><i class="fas fa-backward"></i> {{__('results.leg_back')}}</a>
                    <span href="#" v-else><i class="fas fa-backward"></i> {{__('results.leg_back')}}</span>
                    <div class="stats">{{__('results.set')}} {{parsedContent[currentLeg].setCounter}} {{__('results.leg')}} {{parsedContent[currentLeg].legCounter}}</div>
                    <a href="#" @click="changeLeg(+1)" v-if="currentLeg < parsedContent.length -1"> {{__('results.leg_next')}} <i class="fas fa-forward"></i></a>
                    <span href="#" v-else> {{__('results.leg_next')}} <i class="fas fa-forward"></i></span>
                </div>
                <div class="stats-toggle row">
                    <div class="col-12 text-center p-2">
                        <button type="button" class="btn btn-primary" @click="statsToggle('history')">
                            <i class="fas fa-poll-h"></i>
                            {{__('results.history')}}
                        </button>
                        <button type="button" class="btn btn-info" @click="statsToggle('stats')">
                            <i class="fas fa-poll"></i>
                            {{__('results.leg_statistics')}}
                        </button>

                    </div>
                </div>
                <div class="history shadow-light" v-if="!showStats">
                    <game-asset-game-history
                        :content="historyParser()"
                        :headers="historyHeaders"
                        :players="gm.players"
                        v-if="parsedContent.length > 0"
                    />
                </div>
                <div class="statistics shadow-light" v-if="showStats">
                    <game-asset-statistics
                        :players="gm.players"
                        :game_id="game.id"
                        :leg_id="parsedContent[currentLeg].id"
                    />
                </div>
            </template>
            <template v-if="showGameStats">
                <div class="statistics shadow-light">
                    <game-asset-statistics-game
                            :players="gm.players"
                            :game_id="game.id"
                    />
                </div>
            </template>
            </template>
            <template #modal-footer class="d-flex">
                <div class="statsbuttoncontainer">
                    <button type="button" class="btn btn-info btn-lg" @click.prevent="gameStatsToggle()">
                        <i class="fas fa-poll"></i>
                        <span v-if="!showGameStats">{{__('results.show_leg_statistics')}}</span>
                        <span v-if="showGameStats">{{__('results.show_leg_stat_history')}}</span>
                    </button>
                </div>
                <div class="ml-auto">
                    <game-asset-rematch :game="game"></game-asset-rematch>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import gameAssetRematch from './gameAssetRematch.vue';
    export default {
        components: { gameAssetRematch },
        props: ['game', 'playersProp', 'gm', 'showResults'],
        data() {
            return {
                content: null,
                parsedContent: [],
                players: [],
                legsets: [],
                currentLeg: -1,
                winner: null,
                historyHeaders: [
                    {name: "Geworfen", value: "singlescores"},
                    {name: "Wurf", value: "roundscore"},
                    {name: "Punkte", main: true, value: "score"},
                ],
                showStats: false,
                showGameStats: false,
            }
        },
        created() {
            this.players = this.playersProp;
        },
        watch: {
            showResults: function(newVal, oldVal) {
                if (newVal == true) {
                    this.toggleModal();
                }
            }
        },
        mounted() {
            if (this.game.status == "completed") {
                this.toggleModal();
            } else {
                return;
            }
        },
        methods: {
            toggleModal() {
                setTimeout(() => {
                this.$bvModal.show('modal-game-results');
                //fetch data from game/id/results
                axios.post("/games/" + this.game.id + "/results").then((response) => {
                    this.content = response.data;
                    this.parseContent();
                })
                }, 100);
            },
            changeLeg(offset) {
                this.currentLeg += offset;
            },
            backToMatchmaking() {
                window.location.href = "/matchrequests/";
            },
            historyParser() {
                //parse the content throws to generate a nice viewable score list
                let players = [];
                //sort correctly from players ids in gamemanager
                this.gm.players.forEach(gmplayer => {
                    this.parsedContent[this.currentLeg].players.forEach(player => {
                        if (player && gmplayer.id == player.id) players.push(player);
                    });
                });
                let roundCounter = this.parsedContent[this.currentLeg].roundCounter;
                return {players: players, rounds: roundCounter+1, custom: true}
            },
            statsToggle(show) {
                if (show == 'stats') this.showStats = true;
                if (show == 'history') this.showStats = false;
            },
            gameStatsToggle() {
                this.showGameStats = !this.showGameStats;
            },
            parseContent() {
                if (!this.content) return [];
                this.legsets = [];
                let start = 501;
                this.game.options.forEach(option => {
                    if (option.name == "Start") start = parseInt(option.value);
                });
                this.content.forEach(c => {
                    if (c.content != null) {
                        this.currentLeg += 1;
                        var leg = {};
                        leg.id = c.leg_id;
                        leg.content = c.content;
                        leg.setCounter = c.set + 1;
                        leg.legCounter = c.leg + 1;
                        leg.startplayer = c.content.startPlayer;
                        leg.winner_id = c.winner_id;
                        leg.players = [];

                        c.players.forEach(player => {
                            if (leg.winner_id == player.player_id) {
                                leg.winner = player.player;
                            }
                            leg.players[player.player_id] = {
                                id: player.player_id,
                                start: start,
                                rows: [],
                                avg3dart: 0,
                                avg1dart: 0,
                                winner: player.player_id == leg.winner_id
                            };

                        });

                        leg.players.forEach(player => {
                            leg.roundCounter = 0;
                            player.rows.push({
                                score: player.start,
                                round: "-"
                            })
                            for (let i = 0; i < leg.content.throws.length; i++) {
                                const t = leg.content.throws[i];
                                if (t.player == player.id) {
                                    let singlescores = '';
                                    if (t.singlescores)
                                        t.singlescores.forEach(sc => {
                                            singlescores += sc.str + " ";
                                        });
                                    player.start -= parseInt(t.fullscore);
                                    player.rows.push({
                                        score: player.start,
                                        roundscore: t.fullscore,
                                        singlescores: singlescores,
                                        round: leg.roundCounter+= 1
                                    })
                                    player.avg3dart = (leg.content.start - player.start) / player.rows.length;
                                    player.avg1dart = (leg.content.start - player.start) / player.rows.length / 3;
                                    player.singlescores = singlescores;
                                    player.lastthrow = t.fullscore;
                                    player.score = player.start;
                                }
                            }
                        })
                        if (this.currentLeg == 0) {
                            this.legsets[this.currentLeg] = [];
                            leg.players.forEach(player => {
                                this.legsets[this.currentLeg][player.id] = {
                                    legs: 0,
                                    sets: 0
                                }
                            });
                        } else {
                            this.legsets[this.currentLeg] = [];
                            leg.players.forEach(player => {
                                this.legsets[this.currentLeg][player.id] = {
                                    legs: this.legsets[this.currentLeg-1][player.id].legs,
                                    sets: this.legsets[this.currentLeg-1][player.id].sets
                                }
                            });
                        }

                        leg.players.forEach(player => {
                            if (c.winner_id == player.id) {
                                this.legsets[this.currentLeg][player.id].legs += 1;
                                if (this.legsets[this.currentLeg][player.id].legs == this.game.legs) {
                                    this.legsets[this.currentLeg][player.id].sets += 1;
                                    this.legsets = this.resetLegs(leg.players, this.legsets, this.currentLeg);
                                }
                            }
                        });
                        this.parsedContent.push(leg);
                    }
                });
            },
            resetLegs(players, legsets, currentLeg) {
                players.forEach(player => {
                    legsets[currentLeg][player.id].legs = 0;
                });
                return legsets;
            }
        }
    }
</script>
